import { IHttpApi } from '@cian/http-api';
import { ILogger } from '@cian/logger';
import { IWorkTimeResponse } from '@cian/callback-widget';

import { transformWorkTimeSchedule } from '../../mappers/transformWorkTimeSchedule';
import {
  fetchGetScheduleByUser,
  IGetScheduleByUserRequest,
  IGetScheduleByUserResponse200,
  IGetScheduleByUserResponse400,
} from '../../repositories/work-time/v1/get-schedule-by-user';
import { assertResponseError } from './asserts';

interface IGetWorkTimeScheduleDependencies {
  httpApi: IHttpApi;
  logger: ILogger;
}

export async function getWorkTimeSchedule(
  dependencies: IGetWorkTimeScheduleDependencies,
  parameters: IGetScheduleByUserRequest,
): Promise<IWorkTimeResponse> {
  const { httpApi, logger } = dependencies;

  try {
    const response = await fetchGetScheduleByUser<IGetScheduleByUserResponse200, IGetScheduleByUserResponse400>({
      httpApi,
      parameters,
    });

    assertResponseError(response);

    return transformWorkTimeSchedule(response.response);
  } catch (error) {
    logger.error(error, {
      domain: 'shared.services.getWorkTimeSchedule()',
      parameters: JSON.stringify(parameters),
    });

    throw error;
  }
}
